// components/SupabaseClientContext.tsx
import { createContext, useContext } from 'react';
import { SupabaseClient } from '@supabase/supabase-js';

// Use the default, generic SupabaseClient type for maximum compatibility.
export type SupabaseClientType = SupabaseClient;

export const SupabaseClientContext = createContext<SupabaseClientType | undefined>(undefined);

export const useSupabaseFromContext = (): SupabaseClientType => {
  const client = useContext(SupabaseClientContext);
  if (!client) {
    
    throw new Error("Supabase client not found in context. Did you wrap your component tree with SupabaseClientContext.Provider?");
  }
  return client;
};